import { useState } from "react";
import { Link } from "react-router-dom";

const TESTIMONIALS = [
  {
    quote:
      "Lemon Protector found a big problem with the first car I looked at. The second car passed their inspection so I bought it. I was genuinely happy with how thorough and professional they were throughout.",
    author: "Rich A.",
    location: "Lynbrook, NY",
    service: "Pre-Purchase Inspection",
    rating: 5,
  },
  {
    quote:
      "I was about to buy a car that looked flawless on CARFAX. Lemon Protector found frame damage and flood indicators the history report never mentioned. Saved me from an absolute disaster.",
    author: "David K.",
    location: "Queens, NY",
    service: "450-Point Inspection",
    rating: 5,
  },
  {
    quote:
      "The inspector called me right after finishing and walked through every single issue he found. I used his written report to negotiate $1,200 off the asking price. Incredibly worth the investment.",
    author: "Maria S.",
    location: "Bergen County, NJ",
    service: "Pre-Purchase Inspection",
    rating: 5,
  },
  {
    quote:
      "Professional, thorough, and completely honest. I was an out-of-state buyer looking at a car in Long Island. Lemon Protector made the entire process easy and gave me total confidence.",
    author: "James T.",
    location: "Fairfield, CT",
    service: "Out-of-State Buyer Inspection",
    rating: 5,
  },
  {
    quote:
      "They caught a cracked engine mount and a failing transmission fluid cooler that the dealer said were 'perfectly fine.' Would have been a $3,500 repair within months. Best $139 I ever spent.",
    author: "Kevin R.",
    location: "Westchester County, NY",
    service: "450-Point Inspection",
    rating: 5,
  },
  {
    quote:
      "The detailed report with photos was exceptional. The inspector knew this specific model's common failure points and checked every one. This is a true specialist service — not a generic mechanic.",
    author: "Sandra M.",
    location: "Staten Island, NY",
    service: "Pre-Purchase Inspection",
    rating: 5,
  },
];

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="bg-brand-charcoal py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="font-sans text-xs tracking-widest uppercase text-brand-gold mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-brand-gold" />
              Client Reviews
            </p>
            <h2 className="font-serif text-4xl lg:text-5xl font-semibold text-brand-white leading-tight">
              What Car Buyers Are Saying
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <img
              src="https://lemonprotector.com/images/home/5stars.gif"
              alt="5-star customer reviews — Lemon Protector"
              className="h-7 object-contain"
            />
            <div>
              <p className="font-sans text-sm text-brand-white font-medium">Verified Reviews</p>
              <p className="font-sans text-xs text-brand-gray">Rated 5 stars by buyers across NY, NJ, CT</p>
            </div>
          </div>
        </div>

        {/* Featured large review */}
        <div className="mb-10 bg-brand-black border border-brand-gold/20 rounded-3xl p-8 lg:p-12 relative overflow-hidden">
          <span className="absolute top-4 left-8 font-serif text-[120px] leading-none text-brand-gold/5 select-none pointer-events-none">&ldquo;</span>
          <div className="flex justify-center gap-1 mb-6">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="ri-star-fill text-brand-gold text-xl" />
            ))}
          </div>
          <blockquote className="font-serif text-xl lg:text-2xl text-brand-white italic leading-relaxed text-center max-w-3xl mx-auto mb-8">
            &ldquo;{TESTIMONIALS[activeIndex].quote}&rdquo;
          </blockquote>
          <div className="flex flex-col items-center gap-1.5">
            <p className="font-sans text-sm font-semibold text-brand-white">{TESTIMONIALS[activeIndex].author}</p>
            <p className="font-sans text-xs text-brand-gray">{TESTIMONIALS[activeIndex].location}</p>
            <span className="mt-2 px-3 py-1 rounded-full bg-brand-gold/10 border border-brand-gold/20 text-brand-gold font-sans text-xs whitespace-nowrap">
              {TESTIMONIALS[activeIndex].service}
            </span>
          </div>
        </div>

        {/* Testimonial grid selectors */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {TESTIMONIALS.map((t, i) => (
            <button
              key={i}
              onClick={() => setActiveIndex(i)}
              className={`text-left p-5 rounded-2xl border transition-all duration-300 cursor-pointer ${
                i === activeIndex
                  ? "border-brand-gold/50 bg-brand-black/70"
                  : "border-brand-gold/10 bg-brand-muted/40 hover:border-brand-gold/30"
              }`}
            >
              <div className="flex gap-0.5 mb-2">
                {[...Array(t.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-brand-gold text-xs" />
                ))}
              </div>
              <p className="font-sans text-xs text-brand-gray-light leading-relaxed line-clamp-3 mb-3 italic">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-sans text-xs font-semibold text-brand-white">{t.author}</p>
                  <p className="font-sans text-xs text-brand-gray">{t.location}</p>
                </div>
                {i === activeIndex && (
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-gold shrink-0">
                    <i className="ri-check-line text-brand-black text-xs" />
                  </div>
                )}
              </div>
            </button>
          ))}
        </div>

        {/* Review link */}
        <div className="text-center">
          <a
            href="https://lemonprotector.com/reviews.html"
            rel="nofollow"
            target="_blank"
            className="font-sans text-sm text-brand-gold hover:text-brand-gold-light transition-colors inline-flex items-center gap-2"
          >
            Read more verified customer reviews
            <i className="ri-external-link-line text-base" />
          </a>
        </div>
      </div>
    </section>
  );
}
